module.exports = __webpack_public_path__ + "media/images/icons/new_constitucion_prov-466e5a7bb55f90997ce459619805f299.svg";